import type {
	BusinessObjectIdType,
	HasTokenAssignment,
	ModuleIdType,
	OnlyData,
	ProcessOutgoingFlowInfo,
	UserIdType,
} from '../types.js'
import { assignCommonProperties } from '../util/data/assign-common-properties.js'

import {
	jsonClass,
	jsonProperty,
	jsonMapProperty,
	jsonArrayProperty,
	AnyType,
} from '@sumbricht/json-class-serializer'

export const ProcessTaskTokenStatuses = ['active', 'error']
export type ProcessTaskTokenStatus = (typeof ProcessTaskTokenStatuses)[number]

export const ProcessTaskTokenTypes = {
	user: 'User task',
	script: 'Script task',
} as const
export type ProcessTaskTokenType = keyof typeof ProcessTaskTokenTypes

@jsonClass('BaseTaskToken')
export class BaseTaskToken {
	@jsonProperty(String)
	id: string
	@jsonProperty(String)
	taskType: ProcessTaskTokenType
	@jsonProperty(String)
	taskName: string
	@jsonProperty(AnyType)
	publicMetadata?: Record<string, any> = {}
	@jsonProperty(Number)
	processInstanceId: number
	@jsonProperty(String)
	status: ProcessTaskTokenStatus = 'active'
	@jsonProperty(String)
	errorMessage?: string
	@jsonProperty(String)
	errorStack?: string
}

@jsonClass('UserTaskToken')
export class UserTaskToken extends BaseTaskToken {
	get __type(): string {
		return 'UserTaskToken'
	}
	set __type(_) {
		/*ignore*/
	}

	@jsonProperty(String)
	assignedToUserId: string
	@jsonProperty(String)
	assignedToName: string
	@jsonProperty(String)
	processModuleId: ModuleIdType
	@jsonProperty(String)
	processBoId: BusinessObjectIdType
	@jsonProperty(String)
	screenModuleId: ModuleIdType
	@jsonProperty(String)
	screenBoId: BusinessObjectIdType
	@jsonProperty(String)
	swimlaneId: string
	@jsonProperty(String)
	swimlaneName: string

	constructor(init?: OnlyData<UserTaskToken>) {
		super()
		assignCommonProperties(this, init)
	}

	getUrl() {
		return `/${this.screenModuleId}/t/${this.id}`
	}
}

@jsonClass('UserTaskTokenDetails')
export class UserTaskTokenDetails extends UserTaskToken {
	get __type(): string {
		return 'UserTaskTokenDetails'
	}
	set __type(_) {
		/*ignore*/
	}

	constructor(init?: OnlyData<UserTaskTokenDetails>) {
		super()
		assignCommonProperties(this, init)
	}

	@jsonArrayProperty(AnyType)
	assignments: [string, any][] = []
	@jsonArrayProperty(String)
	outputs: string[] = []
	@jsonArrayProperty(AnyType)
	outgoingFlows: ProcessOutgoingFlowInfo[] = []
	@jsonProperty(String)
	layoutScreenModuleId: ModuleIdType
	@jsonProperty(String)
	layoutScreenBoId: BusinessObjectIdType
}
